import { render, staticRenderFns } from "./ProductAddReviewForm.vue?vue&type=template&id=8911ee7a&scoped=true"
import script from "./ProductAddReviewForm.vue?vue&type=script&lang=ts"
export * from "./ProductAddReviewForm.vue?vue&type=script&lang=ts"
import style0 from "./ProductAddReviewForm.vue?vue&type=style&index=0&id=8911ee7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8911ee7a",
  null
  
)

export default component.exports